<template>
  <BaseCard class="shadow p-4">
    <h1 class="mb-3">
      Conseils
    </h1>
    <div
      v-for="(group, index) in advices"
      :key="group.title"
      :class="index > 0 ? 'border-t pt-3 mt-3' : ''"
    >
      <p class="text-sm text-gray-500 mb-2">
        {{ group.title }}
      </p>
      <div v-if="multiProductAdvices(group).length" class="flex flex-wrap gap-3 mb-2">
        <SupportProgramStaticAdvice
          v-for="advice in multiProductAdvices(group)"
          :key="advice.title"
          :advice="advice"
        />
      </div>
      <div v-if="singleProductAdvices(group).length" class="flex flex-col gap-2">
        <SupportProgramStaticAdviceRow
          v-for="advice in singleProductAdvices(group)"
          :key="advice.title"
          :advice="advice"
        />
      </div>
    </div>
  </BaseCard>
</template>

<script lang="ts" setup>
import BaseCard from '@/core/components/base/BaseCard.vue';
import {SupportProgramStaticAdviceGroup} from "@/program/interfaces/Program";
import SupportProgramStaticAdvice from "@/program/components/support-program/SupportProgramStaticAdvice.vue";
import SupportProgramStaticAdviceRow from "@/program/components/support-program/SupportProgramStaticAdviceRow.vue";

defineProps<{
    advices: SupportProgramStaticAdviceGroup[];
}>();

/**
 * Advices holding a single product are rendered inline as a row,
 * the others keep the card with the products dialog.
 */
const singleProductAdvices = (group: SupportProgramStaticAdviceGroup) => {
    return group.advices.filter((advice) => advice.products.length === 1);
};

const multiProductAdvices = (group: SupportProgramStaticAdviceGroup) => {
    return group.advices.filter((advice) => advice.products.length !== 1);
};
</script>
